<script>
import { mapGetters } from 'vuex'
import BaseButtonV2 from '@/components/lavender/v2/BaseButton.vue'
import { setCashierNewOrderBannerSeen } from '@/utils/local-storage'
import TrackingEvents from '@/plugins/tracking/event'

export default {
  name: 'CashierNewOrderDrawerBanner',
  components: {
    BaseButtonV2,
  },
  computed: {
    ...mapGetters('order', ['drawerOrderIsActive']),
  },
  methods: {
    onCTAClicked() {
      if (this.drawerOrderIsActive) {
        return
      }

      setCashierNewOrderBannerSeen('2')
      this.$track.event(
        TrackingEvents.dashboard_cashier_view_order_creation_preference_changed,
        {
          new_preference: 'v2',
          page_url: this.$router.currentRoute.fullPath,
        }
      )
      window.location.href = '/v2/in-store/new-order'
    },
  },
}
</script>

<template>
  <div class="cashier-new-order-drawer-banner">
    <div class="cashier-new-order-drawer-banner__left">
      <div style="width: 43px; height: 50px;">
        <img
          class="cashier-new-order-drawer-banner__image"
          src="@/assets/images/cashier-new-order.svg"
          alt="cashier-new-order-banner-image"
        />
      </div>
      <div>
        <div class="cashier-new-order-drawer-banner__title">
          {{ $t('cashier_new_order_banner_title') }}
        </div>
        <div class="cashier-new-order-drawer-banner__description">
          {{ $t('cashier_new_order_banner_description') }}
        </div>
      </div>
    </div>
    <el-tooltip
      :content="$t('cashier_banner_cta_disabled')"
      :disabled="!drawerOrderIsActive"
    >
      <BaseButtonV2
        track-id="cashier_banner_cta"
        class="cashier-new-order-drawer-banner__cta"
        :disabled="drawerOrderIsActive"
        @click="onCTAClicked"
      >
        {{ $t('cashier_new_order_banner_cta') }}
      </BaseButtonV2>
    </el-tooltip>
  </div>
</template>

<style lang="scss" scoped>
.cashier-new-order-drawer-banner {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  min-height: 115px;
  padding: 16px 24px;
  overflow: hidden;
  background: linear-gradient(90deg, #f4e9ff 44.71%, #f2e3ff 100%);
  border-radius: var(--tamara-spacing-sm);
}

.cashier-new-order-drawer-banner__left {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: flex-start;
}

.cashier-new-order-drawer-banner__cta {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 32px;
  padding: 8px;
  padding: 16px 24px;
  font-size: var(--tamara-body-small-size);
  font-weight: var(--tamara-body-medium-weight);
  color: var(--tamara-color-content-inverted);
  letter-spacing: -0.18px;
  background: var(--tamara-color-content-high) !important;
  border-color: var(--tamara-color-content-high);
  border-radius: 48px;
}

.cashier-new-order-drawer-banner__title {
  margin-bottom: var(--tamara-spacing-3xs);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-overflow: ellipsis;
  letter-spacing: -0.27px;
  white-space: nowrap;
}

.cashier-new-order-drawer-banner__description {
  font-size: var(--tamara-body-small-size);
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.21px;
}

.cashier-new-order-banner__image {
  object-fit: cover;
  object-position: top left;
  overflow: visible;
}
</style>
